/**
 * Validates and formats price input strings.
 * Accepts comma or dot as decimal separator and restricts to 2 decimal places.
 * 
 * @param {string} inputValue - The raw input value from the event
 * @returns {string|null} - The sanitized value or null if invalid
 */
export const handlePriceChange = (inputValue) => {
    if (inputValue === '') return '';

    // Replace comma with dot for validation
    let value = inputValue.replace(',', '.');

    // Allow digits followed by an optional dot and up to 2 decimal places
    const regex = /^\d*\.?\d{0,2}$/;

    if (regex.test(value)) {
        return value;
    }
    
    return null;
};

/**
 * Normalizes a price string for backend submission (ensures dot separator).
 * 
 * @param {string|number} value - The value to normalize
 * @returns {number} - The numeric value
 */
export const formatPriceForBackend = (value) => {
    if (value === null || value === undefined || value === '') return 0;
    const normalized = value.toString().replace(',', '.');
    return parseFloat(normalized) || 0;
};
